export const userTypes = {
  SIGN_IN_REQUEST: "SIGN_IN_REQUEST",
  SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
  SIGN_IN_FAILURE: "SIGN_IN_FAILURE",

  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
  RESET_PASSWORD_CLOSE: "RESET_PASSWORD_CLOSE",

  LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USER_LOGIN_FAILURE",
  LOGIN_RESET_ERROR: "LOGIN_RESET_ERROR", 

  LOGOUT: "USER_LOGOUT",

  USER_UPDATE_INFO_REQUEST: "USER_UPDATE_INFO_REQUEST",
  USER_UPDATE_INFO_SUCCESS: "USER_UPDATE_INFO_SUCCESS",
  USER_UPDATE_INFO_FAILURE: "USER_UPDATE_INFO_FAILURE",
};
